import { Record, String } from "runtypes";
import { SubmissionCoordinates } from "./coordinates";
export const WalkthroughPermission = SubmissionCoordinates.And(
  Record({
    number: String,
    semester: String,
    email: String
  })
);
//# sourceMappingURL=walkthroughpermission.js.map
